import { Action, combineReducers } from '@ngrx/store';
import * as fromPreviewOrders from './preview-orders.reducer';

export const featureKey = 'preview';

export interface PreviewState {
  [fromPreviewOrders.featureKey]: fromPreviewOrders.State;
}
export function reducers(state: PreviewState, action: Action): PreviewState {
  return combineReducers({
    [fromPreviewOrders.featureKey]: fromPreviewOrders.reducer,
  })(state, action);
}
